import React from 'react';
import { css } from '@emotion/react';
import { i18n_enter_your_email_address } from '@yi/i18n/phrases/i18n_enter_your_email_address';
import { i18n_start_7_day_free_trial__v2 } from '@yi/i18n/phrases/i18n_start_7_day_free_trial__v2';

import { styles as baseButtonStyles } from '~/src/components/buttons';
import { EnterYourEmailForm } from '~/src/components/EnterYourEmailForm';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints, fontWeight } from '~/styles';

const buttonStyles = css(baseButtonStyles.fullWidth, {
  [breakpoints.minTablet]: css(baseButtonStyles.autoWidth, {
    button: {
      paddingLeft: '45px',
      paddingRight: '45px',
    },
  }),
  [breakpoints.minDesktop]: baseButtonStyles.fullWidth,
});

const styles = {
  form: css({
    display: 'grid',
    flexDirection: 'column',
    alignItems: 'center',
    gridTemplateAreas: " '.' '.'",
    rowGap: '16px',
    [breakpoints.minMobileLandscape]: {
      gridTemplateAreas: " '.' '.'",
      gridTemplateColumns: 'unset',
      columnGap: '16px',
      rowGap: '24px',
      justifyItems: 'center',
    },
    [breakpoints.minTablet]: {
      gridTemplateAreas: " '. .'",
      gridTemplateColumns: '1fr auto',
      columnGap: '16px',
      rowGap: '24px',
      justifyItems: 'center',
    },
    [breakpoints.minDesktop]: {
      gridTemplateAreas: " '.' '.'",
      gridTemplateColumns: 'unset',
      rowGap: '24px',
      width: '75%',
    },
  }),
  input: css({
    width: '100%',
    '.MuiFormLabel-root': {
      fontStyle: 'normal',
      fontSize: '15px',
      fontWeight: fontWeight.medium,
      lineHeight: '20px',
      letterSpacing: '0.45px',
      transform: 'translate(20px, 18px) scale(1)',
      position: 'absolute',
      top: '0%',
      margin: '0',
    },
    '.MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: 'translate(16px, 7px) scale(0.75)',
    },
    '.MuiFormLabel-root:not(.Mui-error)': {
      color: 'var(--Grey-Text, #585858)',
      fontSize: '15px',
      letterSpacing: '0.45px',
      [breakpoints.minTablet]: {
        color: 'var(--Grey-Text, #585858)',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontWeight: fontWeight.medium,
        lineHeight: 'normal',
        letterSpacing: '0.8px',
      },
      [breakpoints.minDesktop]: {
        color: 'var(--Grey-Text, #585858)',
        fontSize: '18px',
        fontWeight: fontWeight.medium,
        lineHeight: '22px',
        letterSpacing: '0.9px',
      },
    },

    '.MuiFormLabel-asterisk': {
      display: 'none',
    },

    '.MuiInputBase-root': {
      height: '56px',
      borderRadius: '34px',
      border: '1px solid var(--dark-text-54, rgba(88, 88, 88, 0.4))',
      background: '#fff',
      display: 'flex',
      padding: '17px 17px 17px 24px',
      alignItems: 'center',
      gap: '16px',
    },

    '.MuiInputBase-root:hover, .MuiFilledInput-root.Mui-focused': {
      background: 'white',
    },

    '.MuiInputBase-root:after': {
      content: 'none',
    },
    '.MuiInputBase-root:before': {
      border: 'none !important',
    },

    '.MuiInputBase-input': {
      height: 'auto',
      color: 'var(--Dark-Text)',
      padding: '7px',
      marginTop: '10px',
      fontWeight: fontWeight.medium,
      '&:focus': {
        color: 'var(--Dark-Text)',
        fontWeight: fontWeight.medium,
      },
    },
  }),
  btnWrapper: css({
    width: '100%',
  }),
};

const { Input, SubmitButton } = EnterYourEmailForm;
export const StartFreeTrialForm: React.FC<{ className?: string }> = props => {
  const { locale } = useLocale();
  return (
    <EnterYourEmailForm css={styles.form} {...props}>
      <Input
        label={i18n_enter_your_email_address(locale)}
        fullWidth
        variant="filled"
        css={styles.input}
      />

      <SubmitButton kind="primary" fullWidth containerCss={buttonStyles}>
        {i18n_start_7_day_free_trial__v2(locale)}
      </SubmitButton>
    </EnterYourEmailForm>
  );
};
